import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import { Alert, Check, Info } from './icons'

type Tone = 'info' | 'warn' | 'success' | 'danger'

const ICON: Record<Tone, ReactNode> = {
  info: <Info />,
  warn: <Alert />,
  success: <Check size={16} />,
  danger: <Alert />,
}

export function Notice({ tone = 'info', title, children, className }: { tone?: Tone; title?: string; children: ReactNode; className?: string }) {
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'note'}
      className={clsx(
        'flex gap-3 border-l-2 px-4 py-3 text-small leading-relaxed',
        tone === 'info' && 'border-ink bg-info-wash text-charcoal',
        tone === 'warn' && 'border-warn bg-warn-wash text-charcoal',
        tone === 'success' && 'border-ok bg-ok-wash text-charcoal',
        tone === 'danger' && 'border-danger bg-danger-wash text-charcoal',
        className,
      )}
    >
      <span
        className={clsx(
          'mt-0.5 shrink-0',
          tone === 'info' && 'text-ink',
          tone === 'warn' && 'text-warn',
          tone === 'success' && 'text-ok',
          tone === 'danger' && 'text-danger',
        )}
      >
        {ICON[tone]}
      </span>
      <div className="min-w-0">
        {title && <p className="font-semibold text-ink">{title}</p>}
        <div>{children}</div>
      </div>
    </div>
  )
}
